import React from 'react';
import { Edit, usePermissions, useEditContext, useRecordContext } from 'react-admin';
import { EventV2Form } from '../../components/form/EventV2Form';
import EmptyList from '../../components/misc/EmptyList';

const EventEditTitle = () => {
  const record = useRecordContext();
  if (!record) return <span>Edit Event</span>;
  return <span>{record.slug || record.name || record.id}</span>;
};

/**
 * Event V2 Edit Component
 * Main edit component
 */
export const EventV2Edit = (props) => {
  const { permissions } = usePermissions();

  if (!permissions) return null;

  return (
    <Edit
      title={<EventEditTitle />}
      {...props}
      redirect="show"
      sx={{
        '& .RaEdit-main': {
          maxWidth: '100%',
          width: '100%',
        },
        '& .RaEdit-card': {
          maxWidth: '100%',
          width: '100%',
        },
      }}
    >
      <EventV2EditForm permissions={permissions} />
    </Edit>
  );
};
/**
 * Event V2 Edit Form Component
 * Wrapper component for edit form
 */
const EventV2EditForm = ({ permissions }) => {
  const { record } = useEditContext();

  if (!record || !permissions) {
    return <EmptyList mode="loading" />;
  }

  const { type, dateType } = record;
  const eventType = type;

  return (
    <EventV2Form
      isEdit={true}
      permissions={permissions}
      record={record}
      eventType={eventType}
      dateType={dateType}
    />
  );
};
